import checkmatrix from './checkmatrix';
import categorycomponent from './categorycomponent';
import categorytextarea from './categorytextarea';
export default {
    checkmatrix: checkmatrix,
    categorycomponent: categorycomponent,
    categorytextarea: categorytextarea
};
